<template>
    <div
        class="el-form-card"
        v-loading="isLoading"
        :element-loading-text="$t('message.other.loading')"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="el-form-card__header">
            {{ formText }} {{ $t('form.title.userGroup') }}
            <span
                v-if="this.user && this.user.ContainerId"
                style="font-size: 12px; color: #30c1af"
                >: {{ form.firstName }} {{ form.lastName }}
            </span>
        </div>
        <div class="el-form-card__body">
            <el-form
                ref="form"
                class="dark-form"
                :model="form"
                :rules="rules"
                size="mini"
                label-position="top"
                label-width="125px"
            >
                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="groupName">
                            <v-text-field
                                :label="$t('form.label.groupName')"
                                v-model="form.groupName"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="description">
                            <v-text-field
                                :label="$t('form.label.description')"
                                v-model="form.description"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>
                <el-row v-if="loading">
                    <div
                        class="el-form-card__element-wrapper"
                        style="margin-top: 25px"
                    >
                        <el-row v-loading="loading"></el-row>
                    </div>
                </el-row>
                <div class="button-wrapper flex justify-between items-center">
                    <v-btn
                        v-if="showSubmitBtn"
                        round
                        color="primary"
                        @click="submit"
                        :disabled="loading"
                        dark
                        >{{ formText }}
                    </v-btn>
                    <v-btn round color="dark" @click="cancel()" dark
                        >{{ formText2 }}
                    </v-btn>
                </div>
            </el-form>
        </div>
        <div></div>
    </div>
</template>

<script>
import _ from 'lodash'
import StcPassword from '../Password'
import { mapActions, mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import StcDialog from './../Dialog'

export default {
    name: 'user-group-create',

    props: {
        gates: Array,
        schedules: Array,
    },

    data() {
        return {
            editing: false,
            loading: false,
            user: '',
            actor: {
                ActorID: '',
            },
            containersAndPermissionsModal: false,
            form: {
                containerID: '',
                groupName: '',
                description: '',
                users: [],
            },
            selectedContainers: [],
            treeValueConsistsOf: 'ALL',
            includeSubContainers: false,
            isFlat: true,
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            isApplyBtnVisible: false,
            treeLimit: 2,
            showContainerAndPermissions: false,
            permissionSelectDoneObj: {
                permissions: [],
                unloadingAreas: [],
            },
            userPermissions: [],
            isLoading: false,
            showSubmitBtn: true,
        }
    },

    async created() {
        this.selectedContainers = [this.selectedContainer]
        Events.$on('show-hide-submit-button', (val) => {
            this.showSubmitBtn = val
        })

        // In user group create mode, latest user ID list will be captured here.
        Events.$on('user-manage', async (data) => {
            this.form.users = _.uniq(data)
        })
    },
    mounted() {
        this.form.ContainerID = this.selectedContainer.ContainerID
        Events.$emit('update-user-create-edit-title', true)
        Events.$on('group-editing', async (data) => {
            if (this.$refs.form) {
                await this.$refs.form.resetFields()
            }
            this.editing = true
            Events.$emit('update-user-create-edit-title', false)

            this.user = data
            this.fillFormUser(this.user)
        })
    },

    beforeDestroy() {
        Events.$off('user-manage')
    },

    computed: {
        ...mapGetters(['selectedContainer']),

        formText() {
            return this.editing
                ? this.$t('form.title.update')
                : this.$t('form.title.create')
        },
        formText2() {
            return this.editing
                ? this.$t('form.button.cancel')
                : this.$t('button.text.reset')
        },

        rules() {
            const rules = {
                groupName: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.groupName'),
                        }),
                        trigger: 'blur',
                    },
                ],
                description: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.description'),
                        }),
                        trigger: 'blur',
                    },
                ],
            }

            Vue.nextTick(() => this.$refs.form.clearValidate())

            return rules
        },
    },

    methods: {
        async cancel() {
            try {
                if (this.editing) {
                    await this.$confirm(
                        this.$i18n.i18next.t('message.warning.resetUser', {
                            section: this.$i18n.i18next.t('text.user'),
                        }),
                        'Warning',
                        {
                            confirmButtonText: this.$i18n.i18next.t(
                                'button.text.confirm'
                            ),
                            cancelButtonText: this.$i18n.i18next.t(
                                'button.text.cancel'
                            ),
                            type: 'warning',
                        }
                    )
                    this.closeContainersAndPermissions()
                } else {
                    await this.$confirm(
                        this.$i18n.i18next.t('message.warning.reset', {
                            section: this.$i18n.i18next.t('text.user'),
                        }),
                        'Warning',
                        {
                            confirmButtonText: this.$i18n.i18next.t(
                                'button.text.confirm'
                            ),
                            cancelButtonText: this.$i18n.i18next.t(
                                'button.text.cancel'
                            ),
                            type: 'warning',
                        }
                    )
                    this.reset()
                }

                return true
            } catch (e) {
                return false
            }
        },
        closeContainersAndPermissions() {
            Events.$emit('show-create-or-edit-group-view', false)
        },

        reset() {
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }
            this.resetPermissions()

            this.form.company = this.me.Company

            this.actor = {
                ActorID: '',
            }
            this.user = ''
            this.editing = false
        },

        fillFormUser(group) {
            this.form.containerID = this.selectedContainer.UserGroupContainerID
            this.form.userGroupID = group.UserGroupID
            this.form.groupName = group.GroupName
            this.form.description = group.Description
        },

        async submit() {
            this.loading = true

            try {
                // Validate the user form
                await this.$refs.form.validate()

                let method = this.editing ? 'put' : 'post'
                let url = this.editing
                    ? `UserGroup/${this.form.userGroupID}`
                    : 'UserGroup'

                let userResponse = await this.$http[method](url, this.form)

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.editing
                        ? this.$i18n.i18next.t('message.success.updated', {
                              section: this.$i18n.i18next.t('text.userGroup'),
                          })
                        : this.$i18n.i18next.t('message.success.created', {
                              section: this.$i18n.i18next.t('text.userGroup'),
                          }),
                })

                // Close User Group Create/Edit View
                Events.$emit('show-create-or-edit-group-view', false)
                // Update User Group Listing
                Events.$emit('update-user-group-list')
            } catch (e) {
                console.error(e)
                if (e === false) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `Please fill out all required fields.`,
                    })
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${e.response.data}.`,
                    })
                }
            }

            this.loading = false
        },
    },
}
</script>

<style lang="scss" scoped>
.cell {
    .el-form-item--mini {
        margin-bottom: 0 !important;
    }
}
</style>
<style>
.el-dialog__title {
    color: white;
}

.btnCls:visited {
    background-color: #dd4814 !important;
}

.btnCls:active {
    background-color: #dd4814 !important;
}

.btnCls:focus {
    background-color: #dd4814 !important;
}

.btnCls:hover {
    background-color: #dd4814 !important;
}

.el-dialog {
    margin-top: 5vh !important;
}
</style>
